import { render, staticRenderFns } from "./InitialModalORWService.vue?vue&type=template&id=4f4c1dce&scoped=true&"
import script from "./InitialModalORWService.vue?vue&type=script&lang=js&"
export * from "./InitialModalORWService.vue?vue&type=script&lang=js&"
import style0 from "./InitialModalORWService.vue?vue&type=style&index=0&id=4f4c1dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4c1dce",
  null
  
)

export default component.exports